<template>
  <v-container fluid class="pa-2">

    <div v-if="isLoading" class="d-flex justify-center my-3">
      <v-progress-circular
          color="primary"
          indeterminate
          size="64"
      ></v-progress-circular>
    </div>

    <!-- CHALLENGE ITEMS V2 -->
    <div class="d-flex flex-wrap align-stretch ma-0 pa-0" v-if="!isLoading && translatedChallenges.length">

      <template v-for="item in translatedChallenges">
        <div v-if="item.translation" class="ma-0 pa-2" :class="'col-' + (12 / columns)" :key="item.identifier">
          <v-card
              height="100%"
              link
              flat
              class="rounded-lg d-flex flex-column link-on-hover"
              hover
              @click.prevent="openItem(item)"
          >
            <v-img
                v-if="item.contentStructure && item.contentStructure.asset && item.contentStructure.asset.properties && item.contentStructure.asset.properties.thumbnailUrl"
                :src="item.contentStructure.asset.properties.thumbnailUrl"
                lazy-src="/assets/img/placeholder.png"
                :aspect-ratio="16/9"
                class="grey d-flex justify-start align-end flex-wrap pa-2 ma-4 rounded-lg overflow-hidden"
                eager
                cover
            ></v-img>
<!--            <v-card-title class="text-break"><strong>{{ item.translation.title }}</strong></v-card-title>-->
            <!--            <v-card-subtitle>{{ $moment(item.from).format("DD/MM/YYYY") }} - {{ $moment(item.until).format("DD/MM/YYYY") }}</v-card-subtitle>-->
            <v-card-text class="fill-height pt-0 d-flex flex-column justify-space-between">
              <div>
                <div class="text-break"><strong>{{ item.translation.title }}</strong></div>
                <div v-if="item.translation.shortDescription" v-html="item.translation.shortDescription"></div>
              </div>
              
              <div class="d-flex flex-wrap justify-space-between mt-2" v-if="item.properties && item.properties.challengeType && item.properties.challengeType === 'COMPETITION'">
                <div class="col-12 col-sm-6 ma-0 d-flex flex-nowrap justify-start align-center pa-0">
                  <div class="mr-2">
                    <v-sheet
                        width="60"
                        height="60"
                        min-height="60"
                        min-width="60"
                        color="primary lighten-2"
                        class="d-flex justify-center align-center rounded-lg"
                    >
                      <v-icon color="primary" size="30">fal fa-calendar-days</v-icon>
                    </v-sheet>
                  </div>
                  <div class="ml-2">
                    <div class="text-break font-weight-black">{{ $t('labels.date') }}</div>
                    <div class="primary--text font-weight-black">{{ $moment(item.properties.dataFrom).format('L') }}</div>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </div>
      </template>

    </div>


    <!-- CHALLENGE DIALOG -->
    <v-dialog
        v-model="showItemDialog"
        max-width="600"
        scrollable
    >
      <v-card
          class="rounded-lg d-flex flex-column"
      >
        <v-img
            v-if="selectedItem.contentStructure && selectedItem.contentStructure.asset && selectedItem.contentStructure.asset.properties && selectedItem.contentStructure.asset.properties.thumbnailUrl"
            :src="selectedItem.contentStructure.asset.properties.thumbnailUrl"
            lazy-src="/assets/img/placeholder.png"
            max-height="400"
            :aspect-ratio="16/9"
            class="grey d-flex justify-start align-end flex-wrap pa-2 ma-4 rounded-lg overflow-hidden"
            eager
            cover
        ></v-img>
        <v-btn
            class="mt-3"
            color="primary"
            fab
            depressed
            dark
            small
            absolute
            right
            @click.prevent="showItemDialog = false"
        >
          <v-icon small>fal fa-close</v-icon>
        </v-btn>
        <v-card-text class="fill-height pt-0" v-if="selectedItem.translation">
          <div class="text-break"><strong>{{ selectedItem.translation.title || '' }}</strong></div>
          <div v-if="selectedItem.translation.description" v-html="selectedItem.translation.description"></div>

          <div class="d-flex flex-wrap justify-space-between mt-2" v-if="selectedItem.properties && selectedItem.properties.challengeType && selectedItem.properties.challengeType === 'COMPETITION'">
            <div class="col-12 col-sm-6 ma-0 d-flex flex-nowrap justify-start align-center pa-0">
              <div class="mr-2">
                <v-sheet
                    width="60"
                    height="60"
                    min-height="60"
                    min-width="60"
                    color="primary lighten-2"
                    class="d-flex justify-center align-center rounded-lg"
                >
                  <v-icon color="primary" size="30">fal fa-calendar-days</v-icon>
                </v-sheet>
              </div>
              <div class="ml-2">
                <div class="text-break font-weight-black">{{ $t('labels.date') }}</div>
                <div class="primary--text font-weight-black">{{ $moment(selectedItem.properties.dataFrom).format('L') }}</div>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end mt-auto">
          <template v-if="selectedItem.registrationModule">
            <template v-if="!selectedItem.registrationModule.registered">
              <v-btn
                  color="primary"
                  depressed
                  class="rounded-lg"
                  :loading="registrationLoading"
                  :disabled="!(selectedItem.registrationModule.registerCount < selectedItem.registrationModule.maxParticipants) || !$moment(selectedItem.registrationModule.startRegistrationDate).isSameOrBefore($moment(), 'day') || !$moment(selectedItem.registrationModule.endRegistrationDate).isSameOrAfter($moment(), 'day')"
                  @click.prevent="checkConsentAndRegisterForChallenge()"
              >
                {{ $t('buttons.register') }}
              </v-btn>
            </template>
            <template v-if="selectedItem.registrationModule.registered">
              <v-btn
                  color="primary"
                  depressed
                  class="rounded-lg"
                  :loading="registrationLoading"
                  :disabled="!$moment(selectedItem.registrationModule.startRegistrationDate).isSameOrBefore($moment(), 'day') || !$moment(selectedItem.registrationModule.endRegistrationDate).isSameOrAfter($moment(), 'day')"
                  @click.prevent="deleteRegistrationForChallenge()"
              >
                {{ $t('buttons.deregister') }}
              </v-btn>
            </template>
          </template>
          <template v-else-if="selectedItem.url">
            <v-btn
                color="primary"
                depressed
                class="rounded-lg"
                @click.prevent="navigateExternal(selectedItem.url)"
            >
              {{ $t('buttons.participate') }}
            </v-btn>
          </template>
          <v-btn
              color="primary"
              depressed
              class="rounded-lg"
              @click.prevent="navigate('/challenges/' + selectedItem.identifier)"
          >
            {{ $t('buttons.details') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- CONSENT DIALOG -->
    <m2h-consent-dialog></m2h-consent-dialog>
    
  </v-container>
</template>

<script>

import api from "@/api/api";
import { v4 as uuidv4 } from 'uuid';

export default {
  name: "m2h-challenges",
  data() {
    return {
      isLoading: true,
      challenges: [],
      challengesV2: [],
      showItemDialog: false,
      selectedItem: {},
      registrationLoading: false,
      acceptConsent: false,
      consent: {},
      consentDialogIdentifier: ''
    }
  },
  
  computed: {
    columns() {
      if (this.$vuetify.breakpoint.xl) {
        return 4;
      }

      if (this.$vuetify.breakpoint.lg) {
        return 3;
      }

      if (this.$vuetify.breakpoint.md) {
        return 3;
      }

      if (this.$vuetify.breakpoint.sm) {
        return 2;
      }

      if (this.$vuetify.breakpoint.sm) {
        return 1;
      }

      return 1;
    },

    translatedChallenges() {
      let challenges = [...this.challengesV2]
      challenges.forEach((challenge) => {
        challenge.translation = null
        if (challenge.contentStructure && challenge.contentStructure.asset && challenge.contentStructure.asset.assetTranslations.length){
          if (challenge.contentStructure.asset.assetTranslations.find((t) => t.language === this.$i18n.locale)){
            challenge.translation = challenge.contentStructure.asset.assetTranslations.find((t) => t.language === this.$i18n.locale)
          }
        }
      })
      return challenges
    }
    
  },

  mounted(){
    this.fetchChallengesV2()
    // this.fetchChallenges()
    this.$root.$on('handle-consent-dialog', (data) => {
      if (data.consentDialogIdentifier === this.consentDialogIdentifier){
        this.registerForChallenge() 
      }
    })
  },

  methods: {
    async fetchChallenges(){
      this.isLoading = true
      let challenges = []
        challenges = await api.newsItems.getList("challenge", this.$i18n.locale).then((res) => { return res.data })
      if (challenges.length){
        this.challenges = challenges.sort((a, b) => {
          return this.$moment(a.created).unix() - this.$moment(b.created).unix()
        })
        for (const item of this.challenges) {
          let image = await this.fetchImage(item.imageAssetId)
          let thumbnail = await this.fetchImage(item.thumbnailAssetId)
          item.image = image
          item.thumbnail = thumbnail
        }
      }
      this.isLoading = false
    },
    
    async fetchChallengesV2(){
      this.isLoading = true
      let challenges = []
      challenges = await api.challenges.getList().then((res) => { return res.data })
      if (challenges.length){
        this.challengesV2 = challenges.sort((a, b) => {
          return this.$moment(b.visibleFrom).unix() - this.$moment(a.visibleFrom).unix()
        })
      }
      this.isLoading = false
    },

    async fetchImage(id){
      if (id){
        return await api.newsItems.getSas(id)
            .then((res) => {
              return res.data
            })
            .catch(() => {
              return ''
            })
      } else {
        return ''
      }
    },
    
    async openItem(item){
      this.selectedItem = item
      if (item.registrationModule && item.registrationModule.identifier){
          this.selectedItem.registrationModule.registered = await api.userRegistrations.getRegistrationExists(item.registrationModule.identifier).then((res) => {
              return res.data
          })
          await this.updateRegisterCount()
      }
      this.showItemDialog = true
      this.$root.$emit('post-challenge-opened', { id: item.identifier })
    },

    async registerForChallenge(){
        this.registrationLoading = true
        await this.updateRegisterCount()
        if (this.selectedItem.registrationModule.registerCount < this.selectedItem.registrationModule.maxParticipants){
            let registration = await api.userRegistrations.postRegistrationRegister(this.selectedItem.registrationModule.identifier).then((res) => { return res.data })
            if (registration.identifier){
                this.selectedItem.registrationModule.registered = true
                await this.updateRegisterCount()
                this.$root.$emit('open-snackbar', { mode: "registered", title: this.selectedItem.translation.title })
                this.navigate('/challenges/' + this.selectedItem.identifier)
            }
        }
        this.registrationLoading = false
    },

    async updateRegisterCount(){
        this.selectedItem.registrationModule.registerCount = await api.userRegistrations.getRegistrationCount(this.selectedItem.registrationModule.identifier).then((res) => { return res.data })
    },

    async deleteRegistrationForChallenge(){
        this.registrationLoading = true
        let registration = await api.userRegistrations.getRegistration(this.selectedItem.registrationModule.identifier).then((res) => { return res.data })
        if (registration.identifier){
            await api.userRegistrations.deleteRegistration(registration.identifier)
            this.selectedItem.registrationModule.registered = false
            this.$root.$emit('open-snackbar', { mode: "deregistered", title: this.selectedItem.translation.title })
        }
        await this.updateRegisterCount()
        this.registrationLoading = false
    },
      
    async checkConsent(){
        this.consent = await api.consent.getForLabel(this.selectedItem.registrationModule.consentLabel).then((res) => { return res.data })
        this.acceptConsent = this.consent.approved
    },

    async checkConsentAndRegisterForChallenge(){
        this.registrationLoading = true
        await this.checkConsent()
        if (this.acceptConsent){
            await this.registerForChallenge()
        } else {
            this.consentDialogIdentifier = uuidv4();
            this.$root.$emit('open-consent-dialog', { consentDialogIdentifier: this.consentDialogIdentifier, consentLabel: this.selectedItem.registrationModule.consentLabel })
        }
        this.registrationLoading = false
    },

    navigate(route){
      if (route){
        this.$root.$emit('m2h-loader-show')
        window.location.href = route
      }
    },

    navigateExternal(route){
      if (route){
        window.open(route, '_blank');
      }
    },
  }
}
</script>

<style scoped>

</style>
